import User from 'User/Infrastructure/Translation/en';
import Permission from 'Permission/Infrastructure/Translation/en';
import PermissionGroup from 'PermissionGroup/Infrastructure/Translation/en';
import OrgChart from 'OrgChart/Infrastructure/Translation/en';
import ScheduledCommand from 'ScheduledCommand/Infrastructure/Translation/en';
import Security from 'Shared/Security/Infrastructure/Translation/en';
import UI from 'UI/Infrastructure/Translation/en';
import ProposalProject from 'ProposalProject/ProposalProject/Infrastructure/Translation/en';
import DelegationService from 'DelegationService/DelegationService/Infrastructure/Translation/en';

export const en = {
    ...User,
    ...Permission,
    ...PermissionGroup,
    ...OrgChart,
    ...ScheduledCommand,
    ...Security,
    ...UI,
    ...ProposalProject,
    ...DelegationService,
};